import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { ICompany } from '../../model/company.model';
import { IOffice } from '../../model/office.model';

import { API_CORE } from '../../constant/api-core.const';
import { PermissionSetName } from '../../enum';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  async getCompany(): Promise<ICompany> {
    return CaiApi.get(API_CORE.name, API_CORE.URLs.Company.CurrentCompany, {});
  }

  async getOfficesByCompanyId(companyId: number): Promise<IOffice[]> {
    const url = API_CORE.URLs.Company.OfficesById.replace(
      '{companyId}',
      companyId.toString(),
    );
    return CaiApi.get(API_CORE.name, url, {});
  }

  async getCompanyOffices(
    token?: string,
    roleName?: PermissionSetName,
  ): Promise<IOffice[]> {
    const queryParams: any = {};
    if (token) {
      queryParams.token = token;
    }
    if (roleName) {
      queryParams.roleName = roleName;
    }

    return CaiApi.get(API_CORE.name, API_CORE.URLs.Company.Offices, {
      queryParams,
    });
  }

  async getCompanyOfficesFromIataCass(iatacass: string): Promise<IOffice[]> {
    const url = API_CORE.URLs.Company.OfficesByIataCass.replace(
      '{iatacass}',
      iatacass.toString(),
    );
    return CaiApi.get(API_CORE.name, url, {});
  }

  async checkIataCassExist(
    iata: string,
    cass: string,
    token: string,
  ): Promise<boolean> {
    const extraOptions = {
      response: true,
      queryParams: { iata, cass, token },
    };
    try {
      await CaiApi.get(
        API_CORE.name,
        API_CORE.URLs.Company.OfficeStatus,
        extraOptions,
      );
      return true;
    } catch {
      return false;
    }
  }

  async getOffices(companyId: number, token: string): Promise<IOffice[]> {
    const extraOptions = {
        queryParams: { token },
      },
      url = API_CORE.URLs.Company.OfficesById.replace(
        '{companyId}',
        companyId.toString(),
      );
    return CaiApi.get(API_CORE.name, url, extraOptions);
  }

  async getCompanies(
    type: string,
    haveAirlineBrands: boolean,
    token: string,
  ): Promise<ICompany[]> {
    const extraOptions = {
      header: {
        Authorization: `Bearer ${token}`,
      },
      queryParams: { airline: haveAirlineBrands, token } as any,
    };

    if (type) {
      extraOptions.queryParams.type = type;
    }

    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Company.Companies,
      extraOptions,
    );
  }

  async getCompaniesLight(type: string, token: string): Promise<ICompany[]> {
    const extraOptions = {
      header: {
        Authorization: `Bearer ${token}`,
      },
      queryParams: { mode: 'LIGHT', type, token },
    };
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Company.Companies,
      extraOptions,
    );
  }

  async getCompaniesByDomain(domain: string): Promise<ICompany[]> {
    const url = API_CORE.URLs.Company.CompaniesByDomain.replace(
      '{domain}',
      domain,
    );
    return CaiApi.get(API_CORE.name, url, {});
  }

  async updateOfficeById(
    officeId: number,
    updateOffice: IOffice,
  ): Promise<IOffice> {
    const url = API_CORE.URLs.Company.OfficesByOfficeId.replace(
      '{officeId}',
      officeId.toString(),
    );
    return CaiApi.put(API_CORE.name, url, {
      body: updateOffice,
    });
  }

  async updateCompanyById(
    companyId: number,
    updateCompany: ICompany,
  ): Promise<ICompany> {
    const url = API_CORE.URLs.Company.CompaniesById.replace(
      '{companyId}',
      companyId.toString(),
    );
    return CaiApi.put(API_CORE.name, url, {
      body: updateCompany,
    });
  }
}
